import React from 'react';
import '../template-file-css/document-file-template.css';



export const RRTS_RiskAndSubstanceAssessment = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='RRTS_RiskAndSubstanceAssessment' className='file-pdf-document'>
            <div className='file-template'>
              
            <p className='w-750'>
                    <h3>RISK ASSESSMENT</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtRiskAssessmentName' name='txtRiskAssessmentName' className='add-only' /> </td>
                        <td className='w-250'><input type='date' id='txtRiskAssessmentDate' name='txtRiskAssessmentDate' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>1. Risk of Harm to Self</span>
                    <span className='small'>(Check all the boxes below by indicating either “yes” or “no”)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-625'>
                            <b>Behavior</b>
                        </td>
                        <td className='w-125'>
                            <b>Yes/No</b> </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Prior suicide attempt
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbPriorSuicideAttemptYes' name='rbPriorSuicideAttempt' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbPriorSuicideAttemptNo' name='rbPriorSuicideAttempt' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            No repeated attempts and severity has decreased
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbNoRepeatedAttemptsSeverityYes' name='rbNoRepeatedAttemptsSeverity' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbNoRepeatedAttemptsSeverityNo' name='rbNoRepeatedAttemptsSeverity' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Access to means (weapons, pills, etc)
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbAccessMeansWeaponsPillsEtcYes' name='rbAccessMeansWeaponsPillsEtc' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbAccessMeansWeaponsPillsEtcNo' name='rbAccessMeansWeaponsPillsEtc' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Recent loss
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbPriorRecentLossYes' name='rbPriorRecentLoss' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbPriorRecentLossNo' name='rbPriorRecentLoss' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Presence of behavioral clues (isolation, giving away possessions, rapid improvement in mood, etc)
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbPresenceBehavioralCluesGivingPossessionsRapidYes' name='rbPresenceBehavioralCluesGivingPossessionsRapid' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbPresenceBehavioralCluesGivingPossessionsRapidNo' name='rbPresenceBehavioralCluesGivingPossessionsRapid' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Family history of suicide
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbFamilyHistorySuicideYes' name='rbFamilyHistorySuicide' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbFamilyHistorySuicideNo' name='rbFamilyHistorySuicide' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Terminal illness
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTerminalIllnessYes' name='rbTerminalIllness' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbTerminalIllnessNo' name='rbTerminalIllness' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Repeated attempts, increase in severity
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbRepeatedAttemptsIncreaseSeverityYes' name='rbRepeatedAttemptsIncreaseSeverity' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbRepeatedAttemptsIncreaseSeverityNo' name='rbRepeatedAttemptsIncreaseSeverity' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Stated plan and intent
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbStatedPlanIntentYes' name='rbStatedPlanIntent' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbStatedPlanIntentNo' name='rbStatedPlanIntent' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Substance abuse history
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbSubstanceAbuseHistoryYes' name='rbSubstanceAbuseHistory' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbSubstanceAbuseHistoryNo' name='rbSubstanceAbuseHistory' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Marked lack of support
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbMarkedLackSupportYes' name='rbMarkedLackSupport' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbMarkedLackSupportNo' name='rbMarkedLackSupport' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Symptoms of psychoses with command hallucinations or paranoia
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbSymptomsPsychosesCommandHallucinationsParanoiaYes' name='rbSymptomsPsychosesCommandHallucinationsParanoia' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbSymptomsPsychosesCommandHallucinationsParanoiaNo' name='rbSymptomsPsychosesCommandHallucinationsParanoia' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Suicide of friend or acquaintance
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbSuicideFriendAcqauntanceYes' name='rbSuicideFriendAcqauntance' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbSuicideFriendAcqauntanceNo' name='rbSuicideFriendAcqauntance' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Other:
                            <input type='text' id='txtRiskOfHarmToSelforOthersRatingOtherDescribe' name='txtRiskOfHarmToSelforOthersRatingOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbRiskOfHarmSelfForOtherYes' name='rbRiskOfHarmSelfForOther' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbRiskOfHarmSelfForOtherNo' name='rbRiskOfHarmSelfForOther' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>2. Risk of Harm to Others</span>
                    <span className='small'> (Check all the boxes below by indicating either “yes” or “no”) </span>
                </p>
                <table>
                    <tr>
                        <td className='w-625'>
                            <b>Behavior</b>
                        </td>
                        <td className='w-125'>
                            <b>Yes/No</b> </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Prior acts of violence
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbPriorActViolenceYes' name='rbPriorActViolence' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbPriorActViolenceNo' name='rbPriorActViolence' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Destruction of property
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDestructionPropertyYes' name='rbDestructionProperty' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDestructionPropertyNo' name='rbDestructionProperty' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Arrests for violence
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbArrestsViolenceYes' name='rbArrestsViolence' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbArrestsViolenceNo' name='rbArrestsViolence' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Access to means (weapons)
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbAccessMeansWeaponsYes' name='rbAccessMeansWeapons' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbAccessMeansWeaponsNo' name='rbAccessMeansWeapons' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Harms animals
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHarmsAnimalsYes' name='rbHarmsAnimals' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHarmsAnimalsNo' name='rbHarmsAnimals' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            History of being physically abused
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHistoryBeingPhysicallyAbusedYes' name='rbHistoryBeingPhysicallyAbused' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHistoryBeingPhysicallyAbusedNo' name='rbHistoryBeingPhysicallyAbused' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Fire setting
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbFireSettingYes' name='rbFireSetting' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbFireSettingNo' name='rbFireSetting' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Angry mood, agitation
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbAngryMoodAgitationYes' name='rbAngryMoodAgitation' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbAngryMoodAgitationNo' name='rbAngryMoodAgitation' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Prior hospitalization for danger to others
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbPriorHospitalizationDangerOthersYes' name='rbPriorHospitalizationDangerOthers' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbPriorHospitalizationDangerOthersNo' name='rbPriorHospitalizationDangerOthers' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Substance use (current/ past)
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbSubstaceUseCurrentPastYes' name='rbSubstaceUseCurrentPast' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbSubstaceUseCurrentPastNo' name='rbSubstaceUseCurrentPast' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Symptoms of psychoses with command hallucinations or paranoia
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbPriorSuicideSymtomsPsychosesCommandYes' name='rbPriorSuicideSymtomsPsychosesCommand' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbPriorSuicideSymtomsPsychosesCommandNo' name='rbPriorSuicideSymtomsPsychosesCommand' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Has been physically abusive to others
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHasBeenPhysicallyAbusiveOthersYes' name='rbHasBeenPhysicallyAbusiveOthers' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHasBeenPhysicallyAbusiveOthersNo' name='rbHasBeenPhysicallyAbusiveOthers' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Recipient Safety and Other Risk Factors:</span>
                    <span className='small'> (Check all the boxes below by indicating either “yes” or “no”) </span>
                </p>
                <table>
                    <tr>
                        <td className='w-625'>
                            <b>Risk</b>
                        </td>
                        <td className='w-125'>
                            <b>Yes/No</b> </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Does the recipient feel unsafe in their current living environment?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDoesRecipientUnsafeTheirCurrentLivingEnvironmentYes' name='rbDoesRecipientUnsafeTheirCurrentLivingEnvironment' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDoesRecipientUnsafeTheirCurrentLivingEnvironmentNo' name='rbDoesRecipientUnsafeTheirCurrentLivingEnvironment' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Does the recipient report currently being touched inappropriately by anyone?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDoesRecipientReportCurrentlyYes' name='rbDoesRecipientReportCurrently' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDoesRecipientReportCurrentlyNo' name='rbDoesRecipientReportCurrently' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Does the recipient report ever being touched inappropriately by anyone in the past?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDoesRecipentReportEverBeingTouchedYes' name='rbDoesRecipentReportEverBeingTouched' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDoesRecipentReportEverBeingTouchedNo' name='rbDoesRecipentReportEverBeingTouched' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Does the recipient report anyone in their household/family ever being touched inappropriately by anyone in the past?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDoesRecipentReportAnyoneHouseHoldYes' name='rbDoesRecipentReportAnyoneHouseHold' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDoesRecipentReportAnyoneHouseHoldNo' name='rbDoesRecipentReportAnyoneHouseHold' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Has the recipient or anyone in their household ever been involved with Child or Adult Protective Services?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHasTheRecipientAnyoneHouseHoldInvolvedChildAdultProtectiveYes' name='rbHasTheRecipientAnyoneHouseHoldInvolvedChildAdultProtective' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHasTheRecipientAnyoneHouseHoldInvolvedChildAdultProtectiveNo' name='rbHasTheRecipientAnyoneHouseHoldInvolvedChildAdultProtective' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Other risk:
                            <input type='text' id='txtRiskOfHarmToSelforOthersRatingOtherDescribe' name='txtRiskOfHarmToSelforOthersRatingOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbOtherRiskPriorYes' name='rbOtherRiskPrior' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbOtherRiskPriorNo' name='rbOtherRiskPrior' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Does the recipient report currently being harmed/hurt/abused/threatened by someone in any way?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDoesRecipientReportCurrentlyBeingHarmedYes' name='rbDoesRecipientReportCurrentlyBeingHarmed' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDoesRecipientReportCurrentlyBeingHarmedNo' name='rbDoesRecipientReportCurrentlyBeingHarmed' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Does the recipient report ever report being harmed/hurt/abused/threatened in any way by someone in the past?

                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDoesTheRecipentReportBeingHarmedHurtYes' name='rbDoesTheRecipentReportBeingHarmedHurt' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDoesTheRecipentReportBeingHarmedHurtNo' name='rbDoesTheRecipentReportBeingHarmedHurt' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Does the recipient engage in any sexual behavior that might put them at risk for harm or legal involvement?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDoesRecipientEngageSexualBehaviorYes' name='rbDoesRecipientEngageSexualBehavior' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDoesRecipientEngageSexualBehaviorNo' name='rbDoesRecipientEngageSexualBehavior' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Does the recipient report anyone in their household/family ever being harmed/hurt/abused/threatened by someone in any way in the past?

                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDoesRecipientReportAnyoneHouseHoldFamilyHurtThreatenedYes' name='rbDoesRecipientReportAnyoneHouseHoldFamilyHurtThreatened' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbDoesRecipientReportAnyoneHouseHoldFamilyHurtThreatenedNo' name='rbDoesRecipientReportAnyoneHouseHoldFamilyHurtThreatened' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Other risk:
                            <input type='text' id='txtRiskOfHarmToSelforOthersRatingOtherRisk_2' name='txtRiskOfHarmToSelforOthersRatingOtherRisk_2' className='add-only w-350 custom-add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbPriorOtherRiskTwoYes' name='rbPriorOtherRiskTwo' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbPriorOtherRiskTwoNo' name='rbPriorOtherRiskTwo' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            Other risk:
                            <input type='text' id='txtRiskOfHarmToSelforOthersRatingOtherDescribe_5' name='txtRiskOfHarmToSelforOthersRatingOtherDescribe_5' className='add-only w-350 custom-add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbPriorSuicideAttemptTenOneYes' name='rbPriorSuicideAttemptTenOne' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbPriorSuicideAttemptTenOneNo' name='rbPriorSuicideAttemptTenOne' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>SUBSTANCE ASSESSMENT</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtSubstanceAssessmentName' name='txtSubstanceAssessmentName' className='add-only' /> </td>
                        <td className='w-250'><input type='date' id='txtSubstanceAssessmentDate' name='txtSubstanceAssessmentDate' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Section I - Screening Questions</span>
                    <span className='small'>All recipients should complete Section I - Screening Questions. If a “Yes” is answered on one or more questions in Section I, the provider should ensure a more detailed substance abuse assessment is arranged</span>
                </p>
                <table>
                    <tr>
                        <td className='w-625'>
                            1. Have you tried to hide that you were using alcohol, marijuana or other drugs?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHaveYouTriedToHideThatYes' name='rbHaveYouTriedToHideThat' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHaveYouTriedToHideThatNo' name='rbHaveYouTriedToHideThat' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            2. Have your parents, family, partner, co-workers, classmates or friends complained about your alcohol, marijuana or other drug use? </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHaveYourParentsFamilyPartnerCoworkerClassmatesYes' name='rbHaveYourParentsFamilyPartnerCoworkerClassmates' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHaveYourParentsFamilyPartnerCoworkerClassmatesNo' name='rbHaveYourParentsFamilyPartnerCoworkerClassmates' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            3. Have you used alcohol, marijuana or other drugs weekly?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHaveYouUsedAlcoholMarijuanaYes' name='rbHaveYouUsedAlcoholMarijuana' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHaveYouUsedAlcoholMarijuanaNo' name='rbHaveYouUsedAlcoholMarijuana' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            4. Have you kept using alcohol, marijuana or other drugs even after you knew it could get you into fights or other kinds of legal trouble?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHaveYouKeptUsingAlcoholMarijuanaYes' name='rbHaveYouKeptUsingAlcoholMarijuana' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHaveYouKeptUsingAlcoholMarijuanaNo' name='rbHaveYouKeptUsingAlcoholMarijuana' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-625'>
                            5. Have you spent a lot of time either getting alcohol, marijuana, or other drugs, using them or feeling the effects of them (high, sick)?
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbHaveYouSpentAlotOfTimeEitherGettingAlcoholYes' name='rbHaveYouSpentAlotOfTimeEitherGettingAlcohol' className='add-only' value='Yes' />Yes &nbsp;
                            <input type='radio' id='rbHaveYouSpentAlotOfTimeEitherGettingAlcoholNo' name='rbHaveYouSpentAlotOfTimeEitherGettingAlcohol' className='add-only' value='No' />No&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                <span className='eleHeader'>Disposition</span>
                </p>
                <table>
                    <tr>
                         <td className='w-750'> <input type='checkbox' id='cbNoSubstanceAbuseIssuesIndicatedAnswer' name='cbNoSubstanceAbuseIssuesIndicatedAnswer' className='add-only'  value='NoSubstanceAbuseIssuesIndicatedAnswer'/> No substance abuse issues indicated by answers to screening questions.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbAdditionalSubstanceAbuseAssessment' name='cbAdditionalSubstanceAbuseAssessment' className='add-only' value='AdditionalSubstanceAbuseAssessment'/> Additional substance abuse assessment indicated - person to be referred for further assessment.
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-625'>&nbsp; </td>
                        <td className='signature w-125'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-625'> Referred to: </td>
                        <td className='small w-125'> Date Referred: </td>
                    </tr>
                    <tr>
                        <td className='signature w-625'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-625'> Contact Person for F/U: </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Clinician Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>  



            </div>
        </form>

    )
}  
